import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";

import "./modal.css";
import clsx from "clsx";

const Modal = ({
  isOpen,
  children,
  onClose,
  size = "",
  className = "",
  shouldReturnFocusAfterClose = true,
  overlayColor = ""
}) => {
  if (typeof isOpen !== "boolean") {
    isOpen = isOpen?.length > 0 ? true : false;
  }

  const customStyles = overlayColor
    ? {
        overlay: {
          backgroundColor: overlayColor
        }
      }
    : {};

  return (
    <ReactModal
      className={clsx(
        "modal-dialog modal-dialog-centered modal-container user-selection-text",
        size && `modal-${size}`,
        className
      )}
      overlayClassName="modal fade show modal-overlay"
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      ariaHideApp={false}
      data-testid="modal-test"
      shouldReturnFocusAfterClose={shouldReturnFocusAfterClose}
      style={customStyles}
    >
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.element,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(["", "sm", "lg", "xl"]),
  shouldReturnFocusAfterClose: PropTypes.bool,
  overlayColor: PropTypes.string
};

export default Modal;
